import getIn from 'transmute/getIn';
export const getForwardCommunicatorState = getIn(['threadViewRootReducer', 'floatingForwardCommunicator']);